import { OtcBox } from '../styles';

import { CrossedOutPrice, NewPrice, Price } from './styles';

export const OTCItem = ({ name, strength, imgUrl, altText, markedPrice, price }) => {
  return (
    <OtcBox className="col-xs-4 col-sm-4 col-md-2">
      <div className="thumbnail">
        <img src={imgUrl} alt={altText} />
        <div className="row">
          <div className="col-12 text-center">
            <h5 className="m-0 p-0 mb-1 otc-name">{name}</h5>
          </div>
          <div className="col-12 text-center mt-0 pt-0">{strength}</div>
          <div className="col-12 text-center mt-4">
            {markedPrice ? (
              [<CrossedOutPrice>${price}</CrossedOutPrice>, <NewPrice> {markedPrice}</NewPrice>]
            ) : (
              <Price>${price}</Price>
            )}
          </div>
        </div>
      </div>
    </OtcBox>
  );
};
